module.exports = __webpack_public_path__ + "img/delivery-van.f319b490.png";